import { Model } from '@models/base.model';

export class ReturnReason extends Model {
  title: string;
  subReason: ReturnReason;
}
